import { Card, CardActions, CardContent, CardMedia, Typography, Button } from '@mui/material';
import React from 'react';
// import { Card, Button, div, CardGroup } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './Courses.css'

const Courses = (props) => {
    return (


        <div >
            <Card sx={{ borderColor: 'grey.500', maxWidth: 345, my: 2 }}>
                <CardMedia
                    component="img"
                    alt="green iguana"
                    height="140"
                    image={props?.course?.image}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {props?.course?.course_name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {props?.course?.description}
                    </Typography>
                    <Typography mt={1} variant="body2" color="secondary">
                        <h6>Instructor: {props?.course?.instructor}</h6>
                    </Typography>
                    <Typography mt={1} variant="body2" color="green">
                        <h5>Price: {props?.course?.price}</h5>
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small">Enroll Now</Button>
                    <Button size="small">Details</Button>
                </CardActions>
            </Card>

        </div>
    );
};

export default Courses;